import React from 'react';

// Lightweight, consistent form controls for the PESO wizards.

export const Field = ({ label, required, hint, children }) => (
  <label className="block">
    <span className="text-xs font-medium text-slate-700">
      {label}{required && <span className="text-red-500"> *</span>}
    </span>
    <div className="mt-1">{children}</div>
    {hint && <span className="mt-0.5 block text-[11px] text-slate-500">{hint}</span>}
  </label>
);

const baseInput =
  'w-full rounded-md border border-slate-300 px-3 py-2 text-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500';

export const Txt = ({ value, onChange, type = 'text', ...rest }) => (
  <input
    type={type}
    value={value ?? ''}
    onChange={(e) => onChange(e.target.value)}
    className={baseInput}
    {...rest}
  />
);

export const Sel = ({ value, onChange, options, placeholder = 'Select…' }) => (
  <select value={value ?? ''} onChange={(e) => onChange(e.target.value)} className={baseInput}>
    <option value="">{placeholder}</option>
    {options.map((o) => {
      const val = typeof o === 'string' ? o : o.value;
      const label = typeof o === 'string' ? o : o.label;
      return <option key={val} value={val}>{label}</option>;
    })}
  </select>
);

export const RadioRow = ({ value, onChange, options, name }) => (
  <div className="flex flex-wrap gap-3">
    {options.map((o) => {
      const val = typeof o === 'string' ? o : o.value;
      const label = typeof o === 'string' ? o : o.label;
      return (
        <label key={val} className="inline-flex items-center gap-1.5 py-1 text-sm text-slate-700">
          <input
            type="radio"
            name={name}
            checked={value === val}
            onChange={() => onChange(val)}
            className="h-4 w-4 accent-blue-600"
          />
          {label}
        </label>
      );
    })}
  </div>
);

// Multi-select checkbox group over an array value
export const CheckGroup = ({ value = [], onChange, options, columns = 2 }) => {
  const toggle = (val) => {
    if (value.includes(val)) onChange(value.filter((v) => v !== val));
    else onChange([...value, val]);
  };
  return (
    <div className={`grid gap-1.5 ${columns === 3 ? 'grid-cols-1 sm:grid-cols-3' : 'grid-cols-1 sm:grid-cols-2'}`}>
      {options.map((o) => {
        const val = typeof o === 'string' ? o : o.value;
        const label = typeof o === 'string' ? o : o.label;
        return (
          <label key={val} className="inline-flex items-center gap-1.5 py-1 text-sm text-slate-700">
            <input
              type="checkbox"
              checked={value.includes(val)}
              onChange={() => toggle(val)}
              className="h-4 w-4 accent-blue-600"
            />
            {label}
          </label>
        );
      })}
    </div>
  );
};

export const SectionCard = ({ title, children }) => (
  <div className="rounded-xl border bg-white p-4 shadow-sm sm:p-5">
    {title && <h3 className="mb-3 text-sm font-bold text-slate-800">{title}</h3>}
    <div className="space-y-4">{children}</div>
  </div>
);
